import React, { ComponentType, CSSProperties, ReactNode } from 'react';

import CustomIcon from '@components/utils/CustomIcon';
import { PaletteColor } from '@utils/types';
import Tooltip from '@components/ui/Tooltip/next';

import {
  AnimationDescription,
  CardText,
  IconWrapper,
  NotAnimation,
  TextAnimation,
  WrapperAnimation,
  Animation,
} from './style';

export interface IconLabelProps {
  text: string;
  icon?: ComponentType<React.PropsWithChildren<unknown>>;
  iconLocation?: 'left' | 'right';
  iconSize?: number;
  iconColor?: PaletteColor;
  backgroundColor?: PaletteColor;
  width?: number;
  tooltipText?: string | ReactNode;
  color?: PaletteColor;
  textStyle?: CSSProperties;
  className?: string;
  description?: string;
  roomCard?: boolean;
  badgeText?: string;
}

const IconLabel = ({
  text,
  color = 'black',
  width,
  backgroundColor = 'white',
  textStyle,
  tooltipText,
  icon,
  iconLocation = 'left',
  iconSize = 18,
  iconColor,
  className,
  description,
  roomCard,
  badgeText,
}: IconLabelProps) => (
  <WrapperAnimation
    width={width}
    className={className}
    backgroundColor={backgroundColor}
    iconLocation={iconLocation}
  >
    <Tooltip
      getPopupContainer={(node) => node}
      overlayInnerStyle={{
        width: 'max-content',
        maxWidth: '250px',
        lineHeight: 1.43,
        padding: '12px 15px 11px',
        whiteSpace: 'normal',
        textAlign: 'left',
      }}
      placement='top'
      title={tooltipText}
    >
      <IconWrapper
        hasPointer={Boolean(tooltipText)}
        right={iconLocation === 'right'}
      >
        <CustomIcon fontSize={iconSize} icon={icon} paletteColor={iconColor} />
      </IconWrapper>
    </Tooltip>
    {description && badgeText ? (
      <TextAnimation
        iconLocation={iconLocation}
        style={textStyle}
        color={color}
      >
        <AnimationDescription>
          <span>
            {badgeText}
            <br />
            {text}
            <br />
            {description}
          </span>
        </AnimationDescription>
      </TextAnimation>
    ) : description && !badgeText ? (
      <TextAnimation
        iconLocation={iconLocation}
        style={textStyle}
        color={color}
      >
        <Animation>
          <span>
            {text}
            <br />
            {description}
          </span>
        </Animation>
      </TextAnimation>
    ) : !description && badgeText ? (
      <TextAnimation
        iconLocation={iconLocation}
        style={textStyle}
        color={color}
      >
        <Animation>
          <span>
            {badgeText}
            <br />
            {text}
          </span>
        </Animation>
      </TextAnimation>
    ) : (
      <TextAnimation
        iconLocation={iconLocation}
        style={textStyle}
        color={color}
      >
        {roomCard ? (
          <CardText>{text}</CardText>
        ) : (
          <NotAnimation>{text}</NotAnimation>
        )}
      </TextAnimation>
    )}
  </WrapperAnimation>
);

export default IconLabel;
